import React from 'react';
import { Search, Calendar, Clock, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function BlogPage() {
  const posts = [{
    title: '10 Tips for Acing Your Executive Interview',
    category: 'Interview Prep',
    date: 'Oct 15, 2023',
    readTime: '5 min read',
    excerpt: 'Master the art of storytelling and strategic answering to impress C-suite interviewers.',
    img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'How to Optimize Your LinkedIn Profile for 2024',
    category: 'LinkedIn Tips',
    date: 'Oct 10, 2023',
    readTime: '7 min read',
    excerpt: 'The algorithm has changed. Here is what you need to know to stay visible to recruiters.',
    img: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Resume Keywords That Get You Noticed',
    category: 'Resume Tips',
    date: 'Oct 05, 2023',
    readTime: '4 min read',
    excerpt: 'Stop getting filtered out by ATS. Use these power words to boost your ranking.',
    img: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Negotiating Your Salary: A Step-by-Step Guide',
    category: 'Career Growth',
    date: 'Sep 28, 2023',
    readTime: '6 min read',
    excerpt: "Don't leave money on the table. Learn the tactics pros use to increase their offers.",
    img: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Remote Work Trends: What to Expect',
    category: 'Job Search',
    date: 'Sep 20, 2023',
    readTime: '5 min read',
    excerpt: 'How the landscape of remote work is shifting and where the opportunities are.',
    img: 'https://images.unsplash.com/photo-1593642632823-8f78536788c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Building a Personal Brand Online',
    category: 'Career Growth',
    date: 'Sep 15, 2023',
    readTime: '8 min read',
    excerpt: 'Why your digital footprint matters more than ever in the modern job market.',
    img: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  return <div className="pt-20" data-id="element-183" data-mp="yrk9tv08q091">
      {/* Hero */}
      <section className="bg-navy-900 text-white py-16" data-id="element-184" data-mp="yug7rjc38oxh">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-185" data-mp="k2xtpr2sh4gr">
          <h1 className="text-4xl font-serif font-bold mb-6" data-id="element-186" data-mp="p20p0jsyvwbj">
            Career Resources
          </h1>
          <div className="max-w-xl mx-auto relative" data-id="element-187" data-mp="1cs4uyxtmo85p">
            <input type="text" placeholder="Search articles..." className="w-full px-6 py-3 rounded-full text-gray-900 focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-188" data-mp="1cqjvctsghz0z" />
            <button className="absolute right-2 top-2 p-1 bg-gold-500 rounded-full text-white hover:bg-gold-600" data-id="element-189" data-mp="2xaxf20cqd0ln">
              <Search className="h-6 w-6" data-id="element-190" data-mp="3bzlam6mktabl" />
            </button>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="border-b border-gray-200" data-id="element-191" data-mp="3710h0q1txow4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 overflow-x-auto" data-id="element-192" data-mp="2ja4lbhu969jl">
          <div className="flex space-x-4 min-w-max" data-id="element-193" data-mp="2ebt950ghjmy7">
            {['All', 'Resume Tips', 'Interview Prep', 'Job Search', 'Career Growth', 'LinkedIn Tips'].map((cat, i) => <button key={i} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${i === 0 ? 'bg-navy-900 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-194" data-mp="2oc3nwpi652fh" data-mpi={i}>
                {cat}
              </button>)}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-16 bg-gray-50" data-id="element-195" data-mp="12w1ryxno1lo1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-196" data-mp="17ucz30mkti2k">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-197" data-mp="17t1tqwdhg29c">
            {posts.map((post, index) => <article key={index} className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow flex flex-col h-full" data-id="element-198" data-mp="1hsiz1cotoe4s" data-mpi={index}>
                <div className="h-48 overflow-hidden" data-id="element-199" data-mp="1lrrv4o7c4o3i">
                  <img src={post.img} alt={post.title} className="w-full h-full object-cover transition-transform hover:scale-105 duration-500" data-id="element-200" data-mp="1qm5pqoe6ar74" />
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-201" data-mp="25i4wnvpjqlao">
                  <div className="flex items-center text-xs text-gray-500 mb-3 space-x-4" data-id="element-202" data-mp="25in1hgq9y7u7">
                    <span className="text-gold-600 font-bold uppercase tracking-wider" data-id="element-203" data-mp="3q0xjh6019rub">
                      {post.category}
                    </span>
                    <span className="flex items-center" data-id="element-204" data-mp="3g1zw46ecg4cw">
                      <Calendar className="h-3 w-3 mr-1" data-id="element-205" data-mp="3g2i1ptmwbuxh" /> {post.date}
                    </span>
                    <span className="flex items-center" data-id="element-206" data-mp="3b4gaumj8arbg">
                      <Clock className="h-3 w-3 mr-1" data-id="element-207" data-mp="clsu04bkuf68" /> {post.readTime}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-navy-900 mb-3 line-clamp-2 hover:text-gold-600 cursor-pointer" data-id="element-208" data-mp="7n7vqafvy5kf">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-3 text-sm flex-1" data-id="element-209" data-mp="3u2at7r68yf6i">
                    {post.excerpt}
                  </p>
                  <a href="#" className="text-navy-900 font-medium hover:text-gold-600 inline-flex items-center text-sm mt-auto" data-id="element-210" data-mp="vdby6ehc7z9u">
                    Read Article <ArrowRight className="ml-1 h-3 w-3" data-id="element-211" data-mp="2kteizsta4psx" />
                  </a>
                </div>
              </article>)}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-20 bg-white" data-id="element-212" data-mp="2b2tclj7d6gzg">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-213" data-mp="2g1mqhcqkca05">
          <h2 className="text-3xl font-serif font-bold text-navy-900 mb-4" data-id="element-214" data-mp="2fztle1vllxu9">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-215" data-mp="2648mwdpqnfp9">
            Get the latest career tips and job market insights delivered to your
            inbox.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-216" data-mp="1s6k0v2jxq2im">
            <input type="email" placeholder="Enter your email" className="flex-1 px-6 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-900" data-id="element-217" data-mp="1x43dxz4wc98z" />
            <Button variant="primary" data-id="element-218" data-mp="3rf8n1iyr5dvp">Subscribe</Button>
          </div>
        </div>
      </section>
    </div>;
}